// extracted by mini-css-extract-plugin
module.exports = {"titleListWrapper":"zq","titleListTabWrapper":"zr","breakline":"zs","tab":"zt","active":"zu","arrow":"zv","emblaSlide":"zw"};